import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {
  Toast, ActionSheet, Tab, Tabs,
} from 'vant';

import lyyDialog from 'com/lyyDialog/config';

import QTumeng from '@/utils/qt';
import App from './App';
import router from './router';
import store from './store';
import 'vant/lib/index.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';

import tip from '../static/plugin/tip';

// 引入样式表
import '../static/css/reset.css'; // 重置样式
import '../static/css/common.css'; // 公用样式
import '../static/css/stylus/base.styl';
import './styles/h5-modern.css';

import '../static/js/slider';
// lyyDialog组件
lyyDialog.mount(Vue);

Vue.use(ActionSheet);
Vue.use(VueAxios, axios);
Vue.use(tip);
Vue.use(Toast);
Vue.use(Tab);
Vue.use(Tabs);

Vue.use(lyyDialog);

Vue.prototype.ossImgUrl = 'https://yjzn.oss-cn-shenzhen.aliyuncs.com/';
Vue.prototype.nopic = `${Vue.prototype.ossImgUrl}h5/image/nopic.png`;

Vue.prototype.$QTumeng = QTumeng;

Vue.filter('numberSymbol', (value, decimal, ismoney, ceil) => { /** 将传进去的数字转为带逗号的 */ /** 第一个false没小数 第二个强制开启小数 啥都不传 有小数就返回小数 没有就返回整数 */
  decimal = decimal !== false; /** 传false不要小数  默认为true */
  ceil = ceil === true; /** 是否需要整数部分四舍五入  传true就是整数部分四舍五入 */
  ismoney = ismoney === true; /** 是钱就默认保留两位小数 */
  const val = Number(value); /** 将值转为数字 */
  const parseBefore = !ceil ? parseInt(val).toString() : val.toFixed(0).toString(); /** 取整 */
  const parse = parseBefore.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); /** 每3位加逗号 */
  const floatBefore = val.toFixed(2); /** 取消数 */
  const floatArr = floatBefore.split('.'); /** 讲数转为整数和小数的数组 */
  let float = floatArr[1]; /** 取得小数部分 */
  float = float === '00' ? '' : `.${float}`;
  ismoney ? float = `.${floatArr[1]}` : float;

  return decimal ? parse + float : (ismoney ? parse + float : parse);
});

Vue.directive('iosbugscroll', {
  inserted(el) {
    const ua = navigator.userAgent.toLowerCase();
    if (/micromessenger/.test(ua)) {
      if (/iphone|ipad|ipod/.test(ua)) {
        // input、textarea被组件包装的场景
        const childInput = el.getElementsByTagName('input');
        const childTextarea = el.getElementsByTagName('textarea');
        for (let i = 0; i < childInput.length; i++) {
          childInput[i].onblur = function temporaryRepair() {
            setTimeout(() => {
              checkWxScroll();
            }, 200);
          };
        }

        for (let i = 0; i < childTextarea.length; i++) {
          childTextarea[i].onblur = function temporaryRepair() {
            setTimeout(() => {
              checkWxScroll();
            }, 200);
          };
        }
        // input、textarea中的场景
        el.onblur = function temporaryRepair() {
          setTimeout(() => {
            checkWxScroll();
          }, 200);
        };
      }
    }
  },
});

function checkWxScroll() {
  let currentPosition;
  const speed = 1;
  const timer = setInterval(() => {
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= speed;
    window.scrollTo(0, currentPosition);
    currentPosition += speed;
    window.scrollTo(0, currentPosition);
    clearInterval(timer);
  }, 1);
}

// eslint-disable-next-line no-new
const newVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
export default newVue;



// WEBPACK FOOTER //
// ./src/main.js